$(function(){$("#rangePrices").ionRangeSlider({type:"double",step:2e3,prettify_enabled:!0,prettify_separator:".",hide_min_max:!0,postfix:"&euro;"})});